import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { crashDumpEnvironment } from '../crash-dump-environment';
import { crashLogResponseSchema } from '../schemas/crash-log-response.schema';

/**
 * Retrieve crash logs for a given account, asset, and date range
 * @param account Account ID
 * @param asset Asset ID
 * @param cpVersion CoPilot version
 * @param startDate Start date for crash log retrieval
 * @param endDate End date for crash log retrieval
 * @param maxItems Optional maximum number of crash logs to retrieve
 * @returns Crash log response with items array
 */
export function postRetrieveCrashLogs(
  this: unknown,
  account: string,
  asset: string,
  cpVersion: string,
  startDate: Date,
  endDate: Date,
  maxItems?: number
) {
  const requestBody: {
    account: string;
    asset: string;
    cpVersion: string;
    endDate: string;
    maxItems?: number;
    startDate: string;
  } = {
    account,
    asset,
    cpVersion,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };

  if (maxItems !== undefined) {
    requestBody.maxItems = maxItems;
  }

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(crashDumpEnvironment.resolve(this).retrieveCrashLogsUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(requestBody),
      })
    )
  ).pipe(selectData(crashLogResponseSchema));
}
